<template>
  <div class="video">
    <div v-if="!noPlaceholder" class="video-placeholder">
      <slot name="placeholder">
        <b-skeleton />
      </slot>
    </div>
    <!-- class="lazy" -->
    <video
      v-if="video"
      ref="video"
      muted
      playsinline
      :loop="true"
      :autoplay="true"
      :controls="false"
      :poster="poster"
      loading="lazy"
    >
      <!-- <source v-if="videoMov" :data-src="videoMov.video" type="video/quicktime">
      <source :data-src="video.video" :type="type"> -->
      <source v-if="videoMov" :src="videoMov.video" type="video/quicktime">
      <source :src="video.video" :type="type">
      {{ alt || 'Video' }}
    </video>
  </div>
</template>

<script>
// import lazyVideo from 'marketplace-front-core/utils/lazyVideo'

export default {
  props: {
    video: {
      type: Object,
      required: true
    },
    videoMov: {
      type: Object,
      default: null
    },
    alt: {
      type: String,
      default () {
        return null
      }
    },
    type: {
      type: String,
      default: 'video/mp4'
    },
    poster: {
      type: String,
      default: null
    },
    noPlaceholder: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    // if (this.$refs.video) {
    //   if (Array.isArray(this.$refs.video)) {
    //     this.$refs.video.forEach((video) => {
    //       lazyVideo(video)
    //     })
    //   } else {
    //     lazyVideo(this.$refs.video)
    //   }
    // }

    // if (this.video) {
    //   this.$refs.video.addEventListener('playing', () => this.playing())
    // }
  }
  // beforeDestroy () {
  //   if (this.$refs.video) {
  //     this.$refs.video.removeEventListener('playing', () => this.playing())
  //   }
  // },
  // methods: {
  //   playing () {
  //     if (this.video) {
  //       this.$refs.video.playbackRate = 1
  //       this.$refs.video.play()
  //     }
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.video {
  position: relative;
}

.video-placeholder {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
  :deep(.b-skeleton) {
    position: absolute;
    inset: 0;
    height: 100%;
    background: #fff;
  }
  :deep(.b-skeleton-item) {
    height: 100%;
  }
}

video {
  position: relative;
  z-index: 1;
}

video::-webkit-media-controls,
video::-webkit-media-controls-panel,
video::-webkit-media-controls-play-button,
video::-webkit-media-controls-overlay-play-button {
  display: none !important;
}
</style>
